<template>
  <div :class="`container-fluid bg-${getColorMode.background}`">
    <div class="row" v-if="showView">
      <Sidebar />
      <div :class="`bg-${getColorMode.globalBackground} col px-5`">
        <Header />
        <Breadcrumb
          v-if="$route.name != 'reports' && $route.name != 'index'"
          :breadcrumb="breadcrumb"
          :key="breadcrumbKey"
        />
        <router-view class="content-height" @set-breadcrumb="setBreadcrumb" />
        <Alert :type="alertType" :msg="alertMsg" />
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/Header.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
import Alert from "@/components/Alert.vue";

export default {
  name: "private",
  components: { Alert, Header, Breadcrumb, Footer, Sidebar },
  props: {
    alertMsg: { type: String, default: "" },
    alertType: { type: String, default: "success" },
  },
  data() {
    return {
      breadcrumb: null,
      breadcrumbKey: 0,
      showView: false,
    };
  },
  created() {
    this.$auth.load().then(() => {
      if (this.$auth.check()) {
        this.showView = true;
      } else {
        this.$router.push({ name: "login" });
      }
    });
  },
  methods: {
    setBreadcrumb(breadcrumb) {
      this.breadcrumb = breadcrumb;
      this.breadcrumbKey += 1;
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
